import { render, staticRenderFns } from "./superadmin.vue?vue&type=template&id=001655ee"
import script from "./superadmin.vue?vue&type=script&lang=js"
export * from "./superadmin.vue?vue&type=script&lang=js"
import style0 from "./superadmin.vue?vue&type=style&index=0&id=001655ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports